export default __webpack_public_path__ + "static/media/calender.69c92ae2.svg";